<template>
  <div v-show="display" ref="chatElement" class="chat-window">
    <div class="header" @mousedown.prevent.self="onmousedown">
      <div class="logo" @click="toAboutPage">
        <img src="../../../assets/cosmo.jpg" />
        <span
          style="
            font-weight: bold;
            font-size: 15px;
            color: rgba(255, 255, 255, 0.8);
          "
          >Hai-Industry
        </span>
      </div>
      <div class="close" @click="hideChatWindow">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <div class="body">
      <div id="chatBody" class="chat" @scroll="handleScroll">
        <div v-for="(message, index) in messageArr" :key="index">
          <div :class="[message.from ? 'section-others' : 'section-self']">
            <img v-if="message.from" src="../../../assets/service.jpg" />
            <img v-else src="../../../assets/visitor.jpg" />
            <div class="triangle" />
            <div class="speech-wrapper">
              <div :class="message.from ? '' : 'speech-self'">
                <div v-lazy-container="{ selector: 'img' }" class="speech">
                  <span v-if="message.type === 'text'">
                    {{ message.content }}
                  </span>
                  <span>
                    <img
                      v-if="message.type === 'img'"
                      :id="message.time"
                      :data-src="message.content"
                      data-loading="/loading.gif"
                      class="chat-image"
                      @click="fullScreen(message.content)"
                    />
                  </span>
                </div>
              </div>
              <div class="time">
                <span>{{ message.from || id }}</span>
                {{ formatDate("YY/mm/dd HH:MM", new Date(message.time)) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-row class="chat-tool-btn-group" type="flex" justify="space-between">
        <el-col class="chat-tool-btn-col">
          <el-upload
            class="upload"
            :action="uploadUrl"
            :show-file-list="false"
            :multiple="false"
            accept="image/*"
            :on-success="sendImageMessage"
            :on-error="handleErrorUpload"
            :before-upload="preUpload"
            :disabled="uploadingImg"
          >
            <el-button
              round
              :disabled="uploadingImg"
              size="mini"
              style="padding: 2px; border: none"
              icon="el-icon-picture-outline"
            >
            </el-button>
          </el-upload>
        </el-col>

        <el-col class="chat-tool-btn-col">
          <el-button
            v-show="showToBottom"
            round
            size="mini"
            style="padding: 2px; border: none"
            icon="el-icon-caret-bottom"
            @click="handleToBottom"
          >
          </el-button>
        </el-col>
      </el-row>
      <textarea
        ref="sendText"
        v-model="inputMsg"
        autofocus
        class="input-box"
        placeholder="say something..."
        :disabled="sending"
        @keypress.enter.prevent="sendMessage"
      >
      </textarea>

      <div class="confirm-btn-group">
        <el-button
          class="close"
          size="medium"
          type="info"
          @click="hideChatWindow"
          >close</el-button
        >
        <el-button
          size="medium"
          split-button
          type="primary"
          @click="sendMessage"
        >
          send
        </el-button>
      </div>
    </div>

    <div
      v-if="fullScreenImg"
      class="full-screen-img"
      @click.self="fullScreenImg = false"
    >
      <div class="close-full-screen-image" @click="fullScreenImg = false">
        <i class="el-icon-close"></i>
      </div>
      <img :src="selectedImage" alt="" />
    </div>
  </div>
</template>

<script>
import "./_ChatWindow.scss";
import formatDate from "../../../utils/formatDate";
import { IMUrl, webSocketUrl } from "../../../config/appConfig";

function scrollToBottom(id) {
  const div = document.getElementById(id);
  div.scrollTop = div.scrollHeight - div.clientHeight;
}

export default {
  name: "ChatWindow",
  data() {
    return {
      showToBottom: false,
      talking: this.getIsTalking(),
      uploadTime: "",
      fullScreenImg: false,
      uploadingImg: false,
      selectedImage: "",
      sending: false,
      inputMsg: "",
      id: localStorage.getItem("id") || String(new Date().getTime()),
      webSocket: undefined,
      messageArr: JSON.parse(localStorage.getItem("messageArr")) || [],
    };
  },
  computed: {
    display() {
      return this.$store.state.showCustomerService;
    },
    uploadUrl() {
      return `${IMUrl}/sendImageUpLoad/?UserId=${this.id}`;
    },
  },
  watch: {
    talking: {
      handler(newVal, oldVal) {
        if (newVal && !oldVal) {
          this.online();
        }
      },
      deep: true,
      immediate: true,
    },
    display(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.$nextTick(() => {
          scrollToBottom("chatBody");
        });
      }
    },
    messageArr(newVal) {
      localStorage.setItem("messageArr", JSON.stringify(newVal));
      const chatBody = document.getElementById("chatBody");
      const lastMessage = newVal[newVal.length - 1];
      const { type, content, from, time } = lastMessage;
      //向上滚动超过一屏不自动滚动
      if (chatBody.scrollHeight - chatBody.scrollTop < chatBody.clientHeight + 20) {
        //自动滚动到底部
        if (!from || (from && type === "text")) {
          this.$nextTick(() => {
            scrollToBottom("chatBody");
          });
        } else if (from && type === "img") {
          // todo: 临时解决方案，需要修改
          setTimeout(() => {
            scrollToBottom("chatBody");
          }, 1000);
          // document.getElementById(time).onload = () => {
          //   console.log("load");
          //   scrollToBottom("chatBody")
          // }
        }
      } else {
        //不滚动到底部
        if (from) {
          if (!this.showToBottom) {
            this.showToBottom = true;
          }
          const messageToShow = type === "img" ? "[image]" : content;
          this.$notify({
            title: "New Message",
            message: messageToShow,
            position: "bottom-left",
            showClose: false,
          });
        } else {
          this.$nextTick(() => {
            scrollToBottom("chatBody");
          });
        }
      }
    },
  },
  mounted() {
    if (this.talking) {
      this.online();
      this.getNewMsg();
    }
  },
  methods: {
    formatDate,
    getIsTalking() {
      const storedMessage = JSON.parse(localStorage.getItem("messageArr"));
      const messages = [];
      if (Array.isArray(storedMessage)) {
        messages.push(...storedMessage);
      }
      if (messages.length > 0) {
        const lastMessage = messages[messages.length - 1];
        let waitedTime;
        if (lastMessage.time) {
          waitedTime = new Date().getTime() - Number(lastMessage.time);
        }
        //五分钟之内有过通话，说明正在聊天
        if (waitedTime > 0 && waitedTime < 5 * 60 * 1000) {
          return true;
        }
        return false;
      }
      return false;
    },
    online() {
      const self = this;
      let heartBeatInterval;
      let timeOutCalc;
      const webSocket = new WebSocket(`${webSocketUrl}/goOnline/${this.id}`);
      webSocket.onopen = () => {
        console.log("websocket open");
        localStorage.setItem("id", this.id);
        heartBeatInterval = setInterval(() => {
          try {
            if (webSocket && webSocket.readyState === 1) {
              webSocket.send("heartbeat");
            } else {
              clearInterval(heartBeatInterval);
              if (this.talking) {
                setTimeout(() => {
                  this.online();
                }, 2 * 1000);
              }
            }
            console.log("heartbeat", new Date());
          } catch (e) {}
        }, 40 * 1000);
      };
      webSocket.onmessage = ({ data }) => {
        //新消息到达，重置倒计时
        if (timeOutCalc) {
          console.log("clear");
          clearTimeout(timeOutCalc);
        }
        //19分钟没有新消息，停止心跳
        timeOutCalc = setTimeout(() => {
          console.log("will be off line in 1 minute");
          if (heartBeatInterval) {
            clearInterval(heartBeatInterval);
          }
          self.talking = false;
        }, 19 * 60 * 1000);

        //获取消息内容
        const [command, who] = data.split(" ");
        if (command === "update") {
          self.getNewMsg();
        }
      };
      webSocket.onclose = () => {
        clearInterval(heartBeatInterval);
        if (this.talking) {
          setTimeout(() => {
            this.online();
          }, 2 * 1000);
        }
      };
    },
    onmousedown(e) {
      const chatElement = this.$refs.chatElement;
      const offsetX = e.offsetX;
      const offsetY = e.offsetY;
      const mouseMove = (e) => {
        const left = e.clientX - offsetX <= 10 ? 10 : e.clientX - offsetX;
        const top = e.clientY - offsetY <= 10 ? 10 : e.clientY - offsetY;

        chatElement.style.left = left + "px";
        chatElement.style.top = top + "px";
      };
      const mouseUp = (e) => {
        document.removeEventListener("mousemove", mouseMove);
        document.removeEventListener("mouseup", mouseUp);
      };
      document.addEventListener("mousemove", mouseMove);
      document.addEventListener("mouseup", mouseUp);
    },
    preUpload(file) {
      //限制上传文件大小
      if (file.size / 1024 / 1024 > 10) {
        this.$notify.error({
          title: "Cannot upload",
          message: "The image you selected should be less than 10MB",
          showClose: false,
        });
        return false;
      }
      //限制上传类型
      if (file.type.indexOf("image") === -1) {
        this.$notify.error({
          title: "Cannot upload",
          message: "Wrong file format",
          showClose: false,
        });
        return false;
      }

      const time = new Date().getTime();
      this.uploadTime = time;
      this.uploadingImg = true;
      this.messageArr.push({
        type: "img",
        content: "/loading.gif",
        time,
      });
    },
    sendMessage() {
      if (this.inputMsg.trim().length === 0) {
        return;
      }
      if (!this.talking) {
        this.talking = true;
      }

      const time = new Date().getTime();
      this.sending = true;
      fetch(`${IMUrl}/sendMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          from: this.id,
          type: "text",
          content: this.inputMsg,
          time,
        }),
      }).then((res) => {
        if (res.status === 200) {
          this.messageArr.push({
            type: "text",
            content: this.inputMsg,
            time,
          });
          this.sending = false;
          this.inputMsg = "";
          //自动聚焦文本框
          this.$nextTick(() => {
            this.$refs.sendText.focus();
          });
        } else {
          this.sending = false;
        }
      });
    },
    sendImageMessage(response) {
      const self = this;
      if (response.success) {
        const time = this.uploadTime;
        const uploadedImgUrl = `${IMUrl}/getImageShow?ImageKey=${response.result.objectKey}`;
        this.uploadingImg = false;
        fetch(`${IMUrl}/sendMessage`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            from: this.id,
            type: "img",
            content: uploadedImgUrl,
            time,
          }),
        }).then((res) => {
          if (res.status === 200) {
            const indexToUpdate = self.messageArr.findIndex(
              (item) => item.time === this.uploadTime
            );
            self.messageArr.splice(indexToUpdate, 1, {
              ...self.messageArr[indexToUpdate],
              content: uploadedImgUrl,
            });
          } else {
            this.handleErrorUpload();
          }
        });
      } else {
        this.handleErrorUpload();
        if (response.message) {
          this.$notify.error({
            title: "upload failed",
            message: response.message,
            showClose: false,
          });
        }
      }
    },
    getNewMsg() {
      const self = this;
      fetch(`${IMUrl}/getUserMessage/${this.id}?timestamp=${new Date().getTime()}`, {
        method: "GET",
      })
        .then((res) => {
          if (res.status === 200) {
            return res.json();
          }
        })
        .then((json) => {
          if (json && json.length > 0) {
            if (!this.display) {
              self.$emit("newmessage");
            }
            self.messageArr.push(...json);
          }
        });
    },
    handleErrorUpload(err) {
      if (err) {
        this.$notify.error({
          title: "upload failed",
          message: "cannot connect to server",
          showClose: false,
        });
      }
      this.uploadingImg = false;
      const time = this.uploadTime;
      const indexToUpdate = this.messageArr.findIndex((item) => item.time === time);
      this.messageArr.splice(indexToUpdate, 1, {
        ...this.messageArr[indexToUpdate],
        content: "/failed.jpg",
      });
    },
    fullScreen(url) {
      this.selectedImage = url;
      this.fullScreenImg = true;
    },
    hideChatWindow() {
      this.$store.commit("hideCustomerService");
    },
    toAboutPage() {
      this.$store.commit("hideCustomerService");
      this.$router.push("/about");
    },
    handleToBottom() {
      this.showToBottom = false;
      this.$nextTick(() => {
        scrollToBottom("chatBody");
      });
    },
    handleScroll() {
      const div = document.getElementById("chatBody");
      console.log(div.scrollHeight - div.scrollTop, div.clientHeight);
      if (div.scrollHeight - div.scrollTop < 1.5 * div.clientHeight) {
        this.showToBottom = false;
      }
    },
  },
};
</script>
